import React, { useState } from 'react';
import { ContentCopy } from '@mui/icons-material';
import SplitButton from './SplitButton';
import snackbarHelper from '../helpers/snackbarHelper';
import { getInviteLink } from '../api/users';

const CopyInviteLinkSplitButton = ({
  onInviteClick,
  userId,
  isLoading = false,
  disabled = false,
  label = 'Re-send invite',
  ...props
}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [isSendingInvitation, setIsSendingInvitation] = useState(false);

  const handleInviteClick = async () => {
    setIsSendingInvitation(true);
    try {
      await onInviteClick();
    } finally {
      setIsSendingInvitation(false);
    }
  };

  const handleSplitButtonClick = async (value) => {
    if (value.name === 'copy') {
      setIsFetching(true);
      try {
        const inviteLinkResponse = await getInviteLink(userId);
        const { data } = await inviteLinkResponse.json();

        await navigator.clipboard.writeText(data.url);

        snackbarHelper.info('Invite link copied');
      } catch (error) {
        snackbarHelper.error(error?.message || 'Unable to copy the invite link');
      }

      setIsFetching(false);
      return;
    }

    handleInviteClick();
  };

  return (
    <SplitButton
      isLoading={isLoading || isFetching || isSendingInvitation}
      disabled={disabled}
      handleClick={handleSplitButtonClick}
      variant="contained"
      color="primary"
      {...props}
      options={[
        {
          label,
          name: 'invite',
        },
        {
          label: (
            <>
              <ContentCopy fontSize="small" sx={{ mr: 1 }} /> Copy Link
            </>
          ),
          name: 'copy',
        },
      ]}
    />
  );
};

export default CopyInviteLinkSplitButton;
